import {
  CarItineraryResponse,
  CarItineraryResponseEnum,
  CarItineraryResponseSuccess,
  CarReservationState,
  // CarReservationState,
  CarReservation,
  MyTripsFilter,
  State,
} from "redmond";
import { call, put, select } from "redux-saga/effects";
import { fetchCars } from "../../../api/v1/itinerary/fetchCars";
import { actions } from "../actions";
import { getCars, shouldExcludeCorporateTripsSelector } from "../reducer";
import { getIsCorporateForCar } from "../utils";
import { setUpMyTripsParams } from "./setUpTripsParams";

function filterFailures(reservations: CarReservation[]) {
  return reservations.filter(
    (r) => r.bookResult.status.State !== State.Failure
  );
}

export function* fetchCarsSaga(action: actions.IFetchCars) {
  try {
    const { tripId } = yield call(setUpMyTripsParams, action);
    const carItinerariesResponse: CarItineraryResponse = yield fetchCars(
      action.request
    );
    const carReservations: { [key: string]: CarReservation[] } = yield select(
      getCars
    );
    const updatedResponse = {
      ...carItinerariesResponse,
    };

    if (
      carItinerariesResponse.CarItineraryResponse ===
      CarItineraryResponseEnum.Success
    ) {
      const resp = carItinerariesResponse as CarItineraryResponseSuccess;

      const {
        future = [...carReservations.future],
        present = [...carReservations.present],
        past = [...carReservations.past],
        canceled = [...carReservations.canceled],
      } = resp.reservations;
      const filteredFuture = filterFailures(future);
      const filteredPast = filterFailures(past);
      const filteredPresent = filterFailures(present);
      const filterCanceled = filterFailures(canceled);
      let selectedCarFilter: MyTripsFilter | null = null;
      const excludeCorporateTrips: boolean = yield select(
        shouldExcludeCorporateTripsSelector
      );
      const matchesTripId = (car: CarReservation) =>
        car.bookResult.groundBookingId === tripId &&
        (!excludeCorporateTrips || !getIsCorporateForCar(car));
      let selectedCar = [...filteredFuture, ...filteredPresent].find(
        matchesTripId
      );

      // the reservations we set in Redux is the filtered reservations, not resp.reservations
      (updatedResponse as CarItineraryResponseSuccess).reservations = {
        canceled: filterCanceled,
        future: filteredFuture,
        past: filteredPast,
        present: filteredPresent,
      };

      if (!selectedCar) {
        const canceledCar = filterCanceled.find(matchesTripId);
        if (canceledCar) {
          selectedCar = canceledCar;
          selectedCarFilter = MyTripsFilter.CANCELED_TRIPS;
        } else {
          const pastSelectedCar = filteredPast.find(matchesTripId);
          if (pastSelectedCar) {
            selectedCar = pastSelectedCar;
            selectedCarFilter = MyTripsFilter.PAST_TRIPS;
          }
        }
      }
      if (selectedCarFilter) {
        yield put(actions.setTripsFilter(selectedCarFilter));
        yield put(actions.populateTripQueryParams(action.history, { tripId }));
      }
      if (selectedCar) {
        yield put(actions.setSelectedCar(selectedCar));
      }
      const requestState = action.request.states;
      const updatedReservations: { [key: string]: CarReservation[] } = {
        ...carReservations,
      };
      const reservationTypes: CarReservationState[] = [];

      if (requestState.includes(CarReservationState.Past)) {
        updatedReservations.past = filteredPast;
        reservationTypes.push(CarReservationState.Past);
      }
      if (requestState.includes(CarReservationState.Canceled)) {
        updatedReservations.canceled = filterCanceled;
        reservationTypes.push(CarReservationState.Canceled);
      }
      if (requestState.includes(CarReservationState.Present)) {
        updatedReservations.present = filteredPresent;
        reservationTypes.push(CarReservationState.Present);
      }
      if (requestState.includes(CarReservationState.Future)) {
        updatedReservations.future = filteredFuture;
        reservationTypes.push(CarReservationState.Future);
      }

      yield put(
        actions.setCars(
          {
            reservations: updatedReservations,
            CarItineraryResponse: CarItineraryResponseEnum.Success,
          },
          reservationTypes
        )
      );
    } else {
      yield put(actions.setCars(updatedResponse, action.request.states));
      throw Error("Car itineraries call failed");
    }
  } catch (e) {
    yield put(actions.fetchCarsFailed(action.request));
    console.error(e);
  }
}
